import styled from 'styled-components'

export const CreateEditAssetTypeModalContainer = styled.div`
    .form-group {
        .modal-input {
            margin: 5px 0px;
        }
    }
`
